/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PeerSrmInfo } from './peerSrmInfo';


/**
 * SRM component information
 */
export interface SrmComponentInfo { 
    /**
     * SRM Version
     */
    version?: string;
    /**
     * URL of the SRM
     */
    url?: string;
    /**
     * Organization identifier
     */
    orgId?: string;
    /**
     * Associated vCenter identifier
     */
    vcenterId?: string;
    /**
     * Associated site identifier
     */
    siteId?: string;
    /**
     * SRM license mode.  Possible values include: - legacy_unknown - legacy_eval - legacy_standard - legacy_essentials - legacy_enterprise - legacy_cloud - legacy_term - cloud_trial - cloud_subscription - cloud_offline_subscription 
     */
    licenseType?: string;
    /**
     * Peer SRM component
     */
    peerSrmInfos?: Array<PeerSrmInfo>;
    /**
     * Last heartbeat timestamp in milliseconds
     */
    lastHeartbeatTsInMs?: number;
    /**
     * Number of SRM plans
     */
    planCount?: number;
    /**
     * Number of RWR-enabled plans
     */
    rwrPlanCount?: number;
    /**
     * Number of EDR-enabled plans
     */
    edrEnabledPlanCount?: number;
    /**
     * Total number of virtual machines
     */
    protectedVmCount?: number;
    /**
     * Number of RWR-enabled virtual machines
     */
    rwrVmCount?: number;
    /**
     * Number of EDR-enabled virtual machines
     */
    edrEnabledVmCount?: number;
}

